import $axios from 'axios'
import {
  SAP_LIST_URL,
  TALENT_DETAIL_URL,
  TALENT_SEND_SMS_CODE_URL,
  TALENT_ENROLL_URL,
  TALENT_INVITE_USER_INFO_URL,
  SQUARE_CONFIG_URL,
  SUB_MISSION_HUB_URL,
  GET_FUNCTION_INFO_URL,
  GET_CITY_LIST_URI,
} from '../config/uri'
/**
 * 人才广场-列表
 * @param {*} params
 * @returns
 */
export function sapList(params) {
  return $axios.post(SAP_LIST_URL, params)
}

/**
 * 人才广场-候选人详情
 * @param {*} params
 * @returns
 */
export function squareDetail(params) {
  return $axios.post(TALENT_DETAIL_URL, params)
}
/**
 * 人才报名-发送验证码
 * @param {*} params
 * @returns
 */
export function sendSmsCode(params) {
  return $axios.post(TALENT_SEND_SMS_CODE_URL, params)
}
/**
 * 人才报名-报名
 * @param {*} params
 * @returns
 */
export function squareEnroll(params) {
  return $axios.post(TALENT_ENROLL_URL, params)
}
/**
 * 人才报名-顾问信息
 * @param {*} params
 * @returns
 */
export function getInviteUserInfo(params) {
  return $axios.post(TALENT_INVITE_USER_INFO_URL, params)
}
/**
 * 人才报名-行业/城市配置
 * @param {*} params
 * @returns
 */
export function getConfig(params) {
  return $axios.post(SQUARE_CONFIG_URL, params)
}

/**
 * 人才广场-意向提交
 * @param {*} params
 * @returns
 */
export function submissionHub(params) {
  return $axios.post(SUB_MISSION_HUB_URL, params)
}

/**
 * 职能列表
 * @param {*} params
 * @returns
 */
export function getFunctionInfo(params) {
  return $axios.post(GET_FUNCTION_INFO_URL, params)
}
/**
 * 城市列表
 * @param {*} params
 * @returns
 */
export function getCityList(params) {
  return $axios.post(GET_CITY_LIST_URI, params)
}
